import {Injectable} from "@angular/core";
import {environment} from "../config/environment";
import {MyHttp} from "./http";

@Injectable()
export class DeviceService {

  constructor(private http:MyHttp) {
  }

  saveDevice(token){
    return this.http.post(`${environment.API}/devices`, JSON.stringify({
      token: token
    }))
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/core/device.service.ts